/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccessTokenPermissionAssignmentDto = {
    id: string;
    role: AccessTokenPermissionAssignmentDto.role;
};

export namespace AccessTokenPermissionAssignmentDto {

    export enum role {
        EDITOR = 'Editor',
        MONITOR_RESPONDER = 'Monitor responder',
        CATALOG_EDITOR = 'Catalog editor',
        VIEWER = 'Viewer',
    }


}
